<template>
  <div class="how">
    <BackgroundImage
      class="thin left"
      :data="data?.fullWidthImage"
    />

    <WishesGrid />

    <template
      v-for="(section, index) in sections"
      v-bind:key="index"
    >
      <ComingSoon
        v-if="section.isOutro"
        :title="section.data.description"
      />
      <section
        v-else
        class="faq-category-section"
        :class="{ 'band-night': section.isTier }"
        :ref="`faq-${index}`"
      >
        <FeatureImage
          :isImgLeft="index % 2 === 0"
          :index="index"
          :data="section.data"
          :with-decoration="true"
        />
      </section>
    </template>

    <RotatingWords :data="data?.rotatingWords" />
  </div>
</template>

<script>
import { apollo } from '@/mixins'
import { mapState } from 'pinia'
import { useStore } from '@/stores/index'
import { getFeaturesContent } from '@/data/features'

import BackgroundImage from '@/components/Images/BackgroundImageParallax.vue'
import WishesGrid from '@/components/Sections/WishesGrid.vue'
import FeatureImage from '@/components/Images/FeatureImage.vue'
import ComingSoon from '@/components/Sections/ComingSoon.vue'
import RotatingWords from '@/components/Text/RotatingWords.vue'

export default {
  name: 'FeaturesView',
  mixins: [apollo],
  components: {
    BackgroundImage,
    WishesGrid,
    FeatureImage,
    ComingSoon,
    RotatingWords
  },
  data() {
    return {
      apolloId: 'how'
    }
  },
  computed: {
    ...mapState(useStore, ['language']),
    copy() {
      return getFeaturesContent(this.language)
    },
    /* Strapi sends the tier sections as plain rows; they get a dark
       band and a link to the plans page. The last row (no title) is
       the "more to come" outro. */
    sections() {
      const rows = this.data?.sideImages || []
      return rows.map((row) => {
        const title = String(row?.title || '')
        const isTier = /super|master/i.test(title)
        return {
          data: isTier
            ? { ...row, buttons: [{ label: this.copy.tier.cta, url: '/plans', style: 'primary_button' }] }
            : row,
          isTier,
          isOutro: !title.trim(),
        }
      })
    },
  },
}
</script>

<style lang="scss">
.how .band-night .feature-image .text-teaser h3 {
  opacity: 0.85;
}
</style>
